import { Alert, ButtonLink } from '@designsforhealth/dfh-react-components'
import React, { useState } from 'react'
import styled from 'styled-components'

import { isProductInStock } from '../../lib/cart/item'
import { CartItem } from '../../lib/cart/types'
import StockModal from './StockModal'

export interface StockAlertAndModalProps {
  item: CartItem
}

const StyledAlert = styled(Alert)`
  word-break: break-word;
`

const StyledSpan = styled(ButtonLink)`
  text-decoration: underline;
`

const StockAlertAndModal: React.FC<StockAlertAndModalProps> = ({ item }) => {
  const [isStockModalOpen, setIsStockModalOpen] = useState(false)
  const toggleStockModal = () => {
    setIsStockModalOpen(!isStockModalOpen)
  }

  // TODO: add a check for out of stock status to render alternative messaging
  const stockMessage = !isProductInStock(item.product)
    ? item.product.out_of_stock_message || 'Out of stock'
    : undefined

  if (!stockMessage) {
    return null
  }

  return (
    <>
      <StyledAlert type="error">
        This product is on backorder.{' '}
        <StyledSpan onClick={toggleStockModal}>Click for details.</StyledSpan>
      </StyledAlert>
      <StockModal
        isOpen={isStockModalOpen}
        toggleModal={toggleStockModal}
        stockMessage={stockMessage}
      />
    </>
  )
}

export default StockAlertAndModal
